import { Store } from "pullstate";

export const stateStore = new Store({
  chain: "matic",
  meta: null,
  userAccount: null,
  web3: null,
  walletBalance: 0,
});
